import {dependencyConfiguration} from './infrastructure'
import * as waitscreen from './infrastructure/ixmap/waitscreen'
import * as notifications from 'src/coffee/infrastructure/ixmap/notifications'

dependencyConfiguration.setConfig(JSON.parse(document.getElementById('frontend-config').innerHTML))
dependencyConfiguration.registerWaitscreen(waitscreen)
dependencyConfiguration.registerNotifications(notifications)
